import { render, staticRenderFns } from "./CenterList.vue?vue&type=template&id=79392c4c&"
import script from "./CenterList.vue?vue&type=script&lang=js&"
export * from "./CenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports